export default __webpack_public_path__ + "static/media/grrs_map.afee8c76.svg";